import { useState } from "react";

export default function HowToPlay({
	title = "How To Play",
	selectedGameMode,
	expanded,
	setExpanded,
}) {
	return (
		<div
			onClick={() => setExpanded((prevState) => !prevState)}
			style={{
				// height: expanded ? "100%" : "25px",
				color: "#DDD",
				marginTop: "10px",
				padding: "10px",
				width: expanded ? "95%" : "42%",
				// height: expanded ? "100px" : "",
				overflow: "hidden",
				border: "1px solid #CCCCCCCC",
				borderRadius: "5px",
				cursor: "pointer",
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				// transition: "width 0.1s ease",
			}}
		>
			<p
				style={{
					margin: "0px",
				}}
			>
				{title}
			</p>
			{expanded && (
				<p
					style={{
						marginBottom: "0px",
						textAlign: "center",
					}}
				>
					{selectedGameMode === "asongus" ? (
						<>
							<>
								Asongus is a party game for 2-10 players. Each round a song is
								randomly chosen from someone's Spotify playlist and you have to
								guess whose playlist it's in to earn points. Keep in mind the
								correct answer could be more than one person, as multiple
								players may have the same music taste.
								<p>
									To get started, open Spotify, copy a playlist link, and paste
									it here and submit. Once everyone in your party has submitted
									a playlist, have someone create a game and share the invite
									link or game pin with other players. Have fun!
								</p>
							</>
						</>
					) : selectedGameMode === "noPlaylist" ? (
						<>
							Try using one of your Top Songs of the year playlists! Search Top
							Songs 2024 for example.
							<p>
								Top Songs and Daily Mix 1-6 work with Asongus. To use the other
								auto-generated playlists, such as "Rap Mix" or "Obscure Mix,"
								you have to click "Add to other playlist" and make a new
								playlist with those songs, and then paste that link here.
							</p>
							<p>
								Additionaly, you can convert your liked songs to a playlist at
								this website:
								<> </>
								<a
									target="_blank"
									style={{ color: "lightblue" }}
									href="https://www.chosic.com/spotify-liked-songs-organizer/"
								>
									chosic.com/spotify-liked-songs-organizer/
								</a>{" "}
								(Not affiliated). Once you login with Spotify it starts creating
								the playlist, and takes a few minutes depending on how many
								songs you have in your library.
							</p>
						</>
					) : (
						<>
							Each round a random song is picked from the Spotify Top 50 around
							the world. Guess which country it's charting on to earn points!
							Keep in mind, it's possible for the song to be charting in
							multiple countries.
						</>
					)}
				</p>
			)}
		</div>
	);
}
